import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { ArrowLeft, LogIn } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("chimano_token", data.access_token);
      localStorage.setItem("chimano_admin", JSON.stringify(data.user));
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link
          to="/"
          data-testid="admin-back-home"
          className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.25em] text-[#4A4D4A] hover:text-[#2C392F] mb-8"
        >
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="bg-[#FBF9F4] border border-[#2C392F]/10 rounded-2xl p-10">
          <div className="serif text-3xl text-[#2C392F] leading-tight">ChiMano Admin</div>
          <p className="mt-2 text-sm text-[#4A4D4A]">Sign in to manage content and view enquiries.</p>

          <form onSubmit={submit} className="mt-8 space-y-6" noValidate>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.3em] text-[#985F47] mb-2">Email</label>
              <input
                data-testid="admin-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-[#2C392F]/25 focus:border-[#2C392F] outline-none px-0 py-3 text-[15px]"
              />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.3em] text-[#985F47] mb-2">Password</label>
              <input
                data-testid="admin-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b border-[#2C392F]/25 focus:border-[#2C392F] outline-none px-0 py-3 text-[15px]"
              />
            </div>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#2C392F] text-[#F7F5F0] hover:bg-[#1E2823] disabled:opacity-60 px-7 py-4 rounded-full text-[12px] tracking-[0.2em] uppercase transition-all"
            >
              {loading ? "Signing in…" : "Sign In"} {!loading && <LogIn size={14} />}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
